import routes from '../apps/store-locator/router/routes-config';
import { currentLang } from './lang';
import { stripTrailingSlash } from '../../js/utils/string';
import { setAlternateUrl } from './meta';
export const absoluteUrl = (path) => {
    return window.location.origin + path;
};
export const localizedBasePaths = (appElement) => {
    return JSON.parse(appElement.dataset.basePaths || '{}');
};
export const basePath = (appElement) => {
    return localizedBasePaths(appElement)[currentLang()];
};
export const localizedPathByRoute = (lang, route, basePaths, routeParams) => {
    const routeConfig = routes.find(r => r.name === route.name);
    const params = routeParams ? Object.keys(routeParams) : [];
    let localizedPath = routeConfig.path[lang];
    if (params.length && routeParams) {
        params.forEach(param => {
            localizedPath = localizedPath.replace(new RegExp(`:${param}\\??`), routeParams[param] || '');
        });
    }
    return basePaths[lang] + stripTrailingSlash(localizedPath);
};
export const routeConfigByUrl = (url) => {
    const currentLocale = currentLang();
    const routeConfig = routes.find(r => r.path[currentLocale] === url);
    if (!routeConfig) {
        return null;
    }
    return routeConfig;
};
export const updateLanguageSwitchers = (route, basePaths, routeParams) => {
    const languageSwitchers = document.querySelectorAll('.js__lang-select, .js__data-layer-language-switcher');
    languageSwitchers.forEach(languageSwitcher => {
        languageSwitcher.setAttribute('href', localizedPathByRoute(languageSwitcher.dataset.lang, route, basePaths, routeParams));
    });
};
export const setAlternateUrls = (route, basePaths, routeParams) => {
    const pathLv = localizedPathByRoute('lv', route, basePaths, routeParams);
    const pathRu = localizedPathByRoute('ru', route, basePaths, routeParams);
    setAlternateUrl('lv', absoluteUrl(pathLv));
    setAlternateUrl('ru-lv', absoluteUrl(pathRu));
    setAlternateUrl('x-default', absoluteUrl(pathLv));
};
export const getParamsFromUrl = (pattern, url) => {
    const patternSegments = pattern.split('/');
    const urlSegments = url.split('/');
    const params = {};
    if (patternSegments.length !== urlSegments.length) {
        throw new Error('URL does not match the pattern');
    }
    patternSegments.forEach((segment, index) => {
        if (segment.startsWith(':')) {
            const paramName = segment.slice(1).replace('?', '');
            params[paramName] = urlSegments[index];
        }
        else if (segment !== urlSegments[index]) {
            throw new Error('URL does not match the pattern');
        }
    });
    return params;
};
